import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "sweetalert2/dist/sweetalert2.css";
import "../App.css";
import axiosInstance from '../utilities/axiosInstance';
import { showAlert } from "../components/AlertPopup";

const CreateProject = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const previousRoute = location.state?.previousRoute;
  const defaultFormValues = {
    projectName: "",
    firstName: "",
    lastName: "",
    client: "",
    domain: "",
    assignTo: 0,
  };
  const [formData, setFormData] = useState(defaultFormValues);
  const [clientNameError, setClientNameError] = useState(false);
  const [projectNameError, setProjectNameError] = useState(false);

  const handleChange = (e, isProjectName) => {
    if (e.target.value.length >= 40) {
      alert("You have reached max input character limit");
      return;
    }
    if (isProjectName) {
      e.target.value = ("" + e.target.value).toUpperCase();
    }

    const newValue = e.target.value;

    if (e.target.name === "projectName" && newValue.length > 25) {
      setProjectNameError(true);
      setFormData((prevFormData) => ({
        ...prevFormData,
        [e.target.name]: newValue.slice(0, 25),
      }));
    } else if (e.target.name === "client" && newValue.length > 25) {
      setClientNameError(true);
      setFormData((prevFormData) => ({
        ...prevFormData,
        [e.target.name]: newValue.slice(0, 25),
      }));
    } else {
      setProjectNameError(false);
      setClientNameError(false);
      setFormData((prevFormData) => ({
        ...prevFormData,
        [e.target.name]: newValue,
      }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    await axiosInstance.get(`/allprojects`).then(async (response) => {
      const allProjects = response.data;
      const projectNames = allProjects.map((project) => project.project_Name);
      if (projectNames.includes(formData.projectName.replace("", "-"))) {
        showAlert(
          `A project with name "${formData.projectName}" already exists. Please choose a different name.`,
          "error"
        );
        return;
      } else {
        const response = await axiosInstance.post(`/create/project`, formData);
        const data = response.data;
        showAlert(`${data.message}`, "info");
        setFormData(defaultFormValues);
      }
    });
    // navigate(previousRoute || '/');
    //navigate(previousRoute || '/');
    // document.getElementById("create-project").reset();
  };
  
  return (
    <>
      <form
        className="projectContainer"
        onSubmit={handleSubmit}
        id="create-project"
        style={{ margin: "10px 0px" }}
      >
        {/* <fieldset style={{ border: '1px solid #000', padding: '20px', width: '800px' }}> */}
        {/* <legend>Create Project:</legend> */}
        <div className="project_content">
          <h1>Create Project</h1>
          <label>
            <b>Project Name </b>
          </label>
          <br />
          <input
            type="text"
            name="projectName"
            value={formData.projectName}
            onChange={(e) => handleChange(e, true)}
            required
          ></input>
          <br />
          {projectNameError ? (
            <>
              <label className="errormsg2">
                Max project name limit reached.
              </label>
              <br />
            </>
          ) : null}
          {/*<label><b>Manager</b></label><br />
                <input type="text" placeholder="First name" name="firstName" value={formData.firstName} onChange={handleChange}></input> <br /><br />
        <input type="text" placeholder="Last name" name="lastName" value={formData.lastName} onChange={handleChange}></input><br />*/}
          <label>
            <b>Client</b>
          </label>
          <br />
          <input
            type="text"
            name="client"
            value={formData.client}
            onChange={handleChange}
            required
          ></input>
          <br />
          {clientNameError ? (
            <>
              <label className="errormsg2">
                Max client name limit reached.
              </label>
              <br />
            </>
          ) : null}
          <label>
            <b>Domain</b>
          </label>
          <br />

          <select
            name="domain"
            value={formData.domain}
            onChange={handleChange}
            required
          >
            <option key={""} value={""}>
              {" "}
              Select
            </option>
            <option value="imageTagging">Image tagging</option>
            <option value="textAnnotation">Text annotation</option>
            <option value="videoTagging">Video tagging</option>
            <option value="audioTagging">Audio tagging</option>
          </select>
          <br />
          {/* <label><b>Assign To</b></label><br />
                <select name="assignTo" value={formData.assignTo} onChange={handleChange}>
                    <option key={""} value={""}> Select</option>
                    <option value="0">false</option>
                    <option value="1">true</option>
                </select> */}
          {/* </fieldset> */}
        </div>
        <div className="project_button_cont">
          <button
            type="submit"
            style={{
              width: "100px",
              marginLeft: "0px",
              background: "#09deb0dc",
            }}
          >
            Add Project
          </button>
        </div>
      </form>
    </>
  );
};
export default CreateProject;
